

































































import { WithConfirmModal } from '@/components/organisms/confirm-modal/with-confirm-modal'
import ConfirmModal from '@/components/organisms/ConfirmModal.vue'
import { ContactContext } from '@spa/components/organisms/contact/model/context/contact-context'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { PluginMixin } from '@spa/mixins/plugin'
import { ContactService } from '@spa/services/api/contact'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    SpaErrorDialog,
    ConfirmModal,
  },
})
export default class ContactItem extends Mixins<PluginMixin & WithConfirmModal>(PluginMixin, WithConfirmModal) {
  @Prop()
  id: string

  @Prop()
  firstName: string

  @Prop()
  lastName

  @Prop()
  postalCode: string

  @Prop()
  region: string

  @Prop()
  locality: string

  @Prop()
  streetAddress: string

  @Prop()
  tel: string

  @Prop({ required: true })
  context: ContactContext

  status: Status = Status.Pending

  showModal: boolean = false

  modalMessage: string = ''

  contactService = new ContactService()

  get isLoading() {
    return this.status === Status.Loading
  }

  get name() {
    return `${this.lastName} ${this.firstName}`
  }

  get address() {
    return `${this.region}${this.locality}`
  }

  get isSelected(): boolean {
    const delivery = this.$store.state.orderConfirm.delivery

    if (!delivery) {
      return false
    }

    return delivery.id === this.id
  }

  async remove() {
    const confirmed = await this.confirm()
    if (!confirmed) {
      return
    }

    this.status = Status.Loading

    await this.$store.dispatch('contact/remove', this.id)

    const error = this.errorOnRemove()

    if (error) {
      this.status = Status.Failed
      this.modalMessage = '配送先の削除に失敗しました。'
      this.showModal = true

      return
    }

    await this.$store.dispatch('contact/load', { force: true })

    // Remove from orderConfirm if the contact is used
    const delivery = this.$store.state.orderConfirm.delivery

    if (delivery && _.get(delivery, 'id') === this.id) {
      await this.$store.dispatch('orderConfirm/unsetDelivery')
    }

    this.$router.push(this.context.path.editContact)
  }

  errorOnRemove() {
    const contact = this.$store.getters['contact/get'](this.id)

    if (!contact) {
      return null
    }

    return _.get(contact.error, 'remove')
  }
}

enum Status {
  Pending,
  Loading,
  Failed,
  Completed,
}
